import { render, staticRenderFns } from "./load-more.vue?vue&type=template&id=d1e02876&"
import script from "./load-more.vue?vue&type=script&lang=ts&"
export * from "./load-more.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports